import { N8N_TEAMS_URL } from '@/api/n8n'

export interface MacroAction {
  action_name: string
  action_params: any[]
}

export interface Macro {
  id: string
  name: string
  description: string
  actions: MacroAction[]
  team_ids: number[]
  visibility?: 'global' | 'private'
  is_active: boolean
}

export interface MacroPayload {
  id: string
  name: string
  description: string
  actions: MacroAction[]
  team_ids: number[]
  visibility: 'global' | 'private'
}

async function n8nCall(token: string, body: Record<string, unknown>): Promise<unknown> {
  const res = await fetch(N8N_TEAMS_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ ...body, access_token: token }),
  })
  if (!res.ok) throw new Error(`Erro ${res.status}`)
  return res.json()
}

function parseJsonField<T>(v: T[] | string | null | undefined): T[] {
  if (Array.isArray(v)) return v
  if (typeof v === 'string' && v) try { return JSON.parse(v) } catch { /* */ }
  return []
}

export async function listMacros(token: string): Promise<Macro[]> {
  const data = await n8nCall(token, { command: 'get_macros' })
  const list = Array.isArray(data) ? data as Record<string, unknown>[] : []
  return list.map(m => ({
    id:          String(m.id),
    name:        String(m.name ?? ''),
    description: String(m.description ?? ''),
    actions:     parseJsonField(m.actions as MacroAction[] | string | null),
    team_ids:    parseJsonField(m.team_ids as number[] | string | null),
    visibility:  m.visibility as 'global' | 'private' | undefined,
    is_active:   Boolean(m.is_active),
  }))
}

export async function createMacro(token: string, macro: MacroPayload): Promise<void> {
  await n8nCall(token, { command: 'create_macro', macro })
}

export async function updateMacro(token: string, macro: MacroPayload): Promise<void> {
  await n8nCall(token, { command: 'update_macro', macro })
}

export async function deleteMacro(token: string, macroId: string): Promise<void> {
  await n8nCall(token, { command: 'delete_macro', macro_id: macroId })
}
